import { render } from "./PNBBaseFormView.vue?vue&type=template&id=511f43ec&scoped=true"
import script from "./PNBBaseFormView.vue?vue&type=script&lang=js"
export * from "./PNBBaseFormView.vue?vue&type=script&lang=js"

import "./PNBBaseFormView.vue?vue&type=style&index=0&id=511f43ec&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511f43ec"]])

export default __exports__